import {SVGProps} from 'react';

interface CheckIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const CheckIcon = ({className, ...props}: CheckIconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    <path d="M9 12l2 2 4-4" />
    <circle cx="12" cy="12" r="10" />
  </svg>
);
